import { InjectionToken, inject } from "@angular/core";
import { APP_CONFIG, AppHostService, PersistentStore } from "app/core";
import { persistentUtil } from "app/core/util/persistent.util";
import { UserStoreDefaultImpl } from "./user.default.store";
import { UserStoreIdrhImpl } from "./user.idrh.store";
import { UserStoreOidcImpl } from "./user.oidc.store";
import { PersistedUser, UserRights } from "./user.model";
import { UserStore } from "./user.store";

/** Dependency injection tokens */
export const USER_RIGHTS_PERSISTENT_STORE = new InjectionToken<PersistentStore<UserRights>>(
  "USER_RIGHTS_PERSISTENT_STORE",
  {
    factory: () => {
      const config = inject(APP_CONFIG);
      const storeId = config.botName + "UserRights";
      const modelKeys = ["canWrite"];
      const eventId = "canWrite";
      return persistentUtil.buildPersistentStore<UserRights>(storeId, modelKeys, 0, eventId);
    },
  }
);

export const USER_PERSISTENT_STORE = new InjectionToken<PersistentStore<PersistedUser>>(
  "USER_PERSISTENT_STORE",
  {
    factory: () => {
      const config = inject(APP_CONFIG);
      if (config.authType === "oidc") {
        return persistentUtil.buildPersistentStore<PersistedUser>(
          "",
          ["sessionId"],
          0,
          "userSession"
        );
      }
      const localStorageKeys =
        config.authType === "plumeSysId"
          ? ["sys_id", "idrh", "IDRH", "user-jwt"]
          : ["idrh", "IDRH", "user-jwt"];
      return persistentUtil.buildPersistentStore<PersistedUser>(
        "",
        localStorageKeys,
        0,
        "userIdrh"
      );
    },
  }
);

export const USER_STORE = new InjectionToken<UserStore>("USER_STORE", {
  factory: () => {
    const config = inject(APP_CONFIG);

    switch (config.authType) {
      case "idrh":
      case "plumeSysId":
        return new UserStoreIdrhImpl(
          config.authRequired ?? false,
          config.authType === "plumeSysId",
          inject(AppHostService),
          inject(USER_PERSISTENT_STORE),
          config
        );
      case "oidc": {
        if (!config.auth) {
          console.error(
            '[config] authType is "oidc" but config.auth is missing: authentication will be skipped.'
          );
        }
        return new UserStoreOidcImpl();
      }
      default:
        return new UserStoreDefaultImpl();
    }
  },
});
